const ThirdRowSeating = () => (
  <svg width="71" height="70" viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4042_158089)">
      <path
        d="M57.5744 38.4173C50.3343 37.5625 48.6298 38.2736 47.9016 39.2006C47.3626 39.8867 47.4248 40.9432 47.8758 41.6901L49.99 45.1913C50.3479 45.784 50.9875 46.1484 51.6797 46.1607C54.1603 46.2047 55.1159 46.281 57.7182 46.3292C60.3733 46.3784 61.8507 45.947 62.9672 45.0221C63.2205 44.8122 63.3881 44.5205 63.4846 44.206L69.3875 24.9602C69.5847 24.3174 69.1039 23.667 68.4315 23.667H66.8057C66.398 23.667 65.9951 23.7834 65.6895 24.0534C62.9851 26.442 60.9118 32.5261 59.8543 36.8278C59.6026 37.8517 58.6215 38.541 57.5744 38.4173Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M35.0533 38.4217C27.6579 37.5521 25.4957 38.2855 24.4567 39.2267C23.7657 39.8527 23.785 40.9878 24.2971 41.7669L26.5899 45.2546C26.9556 45.8109 27.5757 46.148 28.2414 46.1583C31.0614 46.202 32.1286 46.2802 35.0127 46.3292C37.9069 46.3785 39.5158 45.9459 40.7318 45.0185C41.0029 44.8117 41.1871 44.5152 41.2951 44.1919L47.7088 24.9837C47.925 24.3361 47.443 23.667 46.7603 23.667H44.8076C44.4266 23.667 44.0498 23.7686 43.751 24.0051C40.7684 26.3662 38.4837 32.5336 37.3279 36.8667C37.0595 37.8728 36.0874 38.5433 35.0533 38.4217Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12.2423 38.4173C5.00229 37.5625 3.29778 38.2736 2.56956 39.2006C2.03056 39.8867 2.09274 40.9432 2.54375 41.6901L4.65796 45.1913C5.01583 45.784 5.65548 46.1484 6.34768 46.1607C8.82825 46.2047 9.78387 46.281 12.3862 46.3292C15.0412 46.3784 16.5187 45.947 17.6352 45.0221C17.8885 44.8122 18.0561 44.5205 18.1526 44.206L24.0555 24.9602C24.2527 24.3174 23.7719 23.667 23.0995 23.667H21.4737C21.0659 23.667 20.6631 23.7834 20.3575 24.0534C17.653 26.442 15.5798 32.5261 14.5223 36.8278C14.2706 37.8517 13.2895 38.541 12.2423 38.4173Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_4042_158089">
        <rect width="70" height="70" fill="white" transform="translate(0.928711)" />
      </clipPath>
    </defs>
  </svg>
);

export default ThirdRowSeating;
